import { render, staticRenderFns } from "./SimpleErrorLine.vue?vue&type=template&id=5b2aaec6"
import script from "./SimpleErrorLine.vue?vue&type=script&lang=ts"
export * from "./SimpleErrorLine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports